import { render, staticRenderFns } from "./file-detail.vue?vue&type=template&id=0f3efb64&scoped=true"
import script from "./file-detail.vue?vue&type=script&lang=js"
export * from "./file-detail.vue?vue&type=script&lang=js"
import style0 from "./file-detail.vue?vue&type=style&index=0&id=0f3efb64&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3efb64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f3efb64')) {
      api.createRecord('0f3efb64', component.options)
    } else {
      api.reload('0f3efb64', component.options)
    }
    module.hot.accept("./file-detail.vue?vue&type=template&id=0f3efb64&scoped=true", function () {
      api.rerender('0f3efb64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/groupReporting/file-detail.vue"
export default component.exports